import declare from "dojo/_base/declare";
import StringRen from "csi/heading/String";
import xml from "csi/xml";

const CompanyCustomFontPreview = declare(StringRen, {

	/**
	 * @override
	 * Render font preview
	 */
	toHtmlStatic: function(ctx, h, refNode, actionData) {
		const { style } = refNode;
		style.fontSize = "24px";

		const node = ctx.getNode();
		style.fontFamily = node[xml.ATTR_NAME];
		this.inherited(arguments);
	},

});

export = CompanyCustomFontPreview;